export const FIELDS = {
  username: {
    label: 'Username',
    id: 'username'
  },
  password: {
    label: 'Password',
    id: 'password'
  },
  confirmPassword: {
    label: 'Confirm password',
    id: 'confirmPassword'
  },
  oldPassword: {
    label: 'Old password',
    id: 'oldPassword'
  },
  newPassword: {
    label: 'New password',
    id: 'newPassword'
  },
  email: {
    label: 'Email',
    id: 'email'
  },
  authyCode: {
    label: 'Enter the 6-digit code from Authy',
    id: 'authy'
  }
}
